import { Box } from "@mui/material";
import HeroContents from "./hero-contents/hero-contents";
import heroVideo from "../../../../assets/hero.mp4";
import heroPoster from "../../../../assets/images/bg2.webp";
import { StyleWrapper } from "./hero-section.styles";

const HeroSection = () => {
  return (
    <StyleWrapper>
      <video
        className="hero-video"
        src={heroVideo}
        poster={heroPoster}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      />
      <Box className="hero-red-rect" />
      <Box className="hero-red-x" />
      <HeroContents />
    </StyleWrapper>
  );
};

export default HeroSection;
